import type { AudioVideoEventAttributes, EventName } from 'amazon-chime-sdk-js';
import { Subject } from 'rxjs';

import type { HearingPhoneWithDisconnectReason } from 'features/call/call-hearing/interfaces';
import type { TranscriptCaption } from 'features/voice-meeting/interfaces';
import type { CallDirection } from 'features/voice-session/interfaces';

export interface AttendeeIdPresence {
  attendeeId: string;
  present: boolean;
  externalUserId?: string;
  dropped?: boolean;
}

export class VoiceMeetingEventBus {
  static hearingCallDeclined$ = new Subject<HearingPhoneWithDisconnectReason>();

  static finishVoiceSession$ = new Subject<void>();

  static fatalError$ = new Subject<Error>();

  static resetVoiceSession$ = new Subject<void>();
  static resetVoiceSessionTeamingLeave$ = new Subject<void>();

  static attendeeIdPresence$ = new Subject<AttendeeIdPresence>();
  static meetingError$ = new Subject<{
    name: EventName;
    attributes: AudioVideoEventAttributes;
  }>();

  static meetingStatusChange$ = new Subject<string>();

  static callDirectionChanged$ = new Subject<CallDirection>();

  static transcriptCaption$ = new Subject<TranscriptCaption>();
}
